import { PetTypeIds } from "@spike/model";
import moment from "moment";
export var convertToAppointment = function (appointmentDto, masterData, timeZone, customerDeleted) {
    var _a;
    return {
        id: appointmentDto.id,
        uuid: appointmentDto.uuid,
        bookingId: appointmentDto.booking_id,
        pet: {
            id: appointmentDto.pet_id,
            name: appointmentDto.pet_name,
            breed: convertBreed(appointmentDto, masterData),
            type: masterData.petTypes.find(function (pt) { return pt.id === appointmentDto.pet_type; }),
            hasMedicalConditions: appointmentDto.has_medical_conditions,
            deceased: appointmentDto.pet_deceased,
            image: appointmentDto.pet_image,
            hasNegativePersonalities: appointmentDto.has_negative_personalities,
        },
        customer: {
            id: appointmentDto.customer_id,
            firstName: appointmentDto.customer_first_name,
            lastName: appointmentDto.customer_last_name,
            phone: appointmentDto.customer_phone,
            email: appointmentDto.customer_email,
            deleted: (_a = appointmentDto.customer_deleted) !== null && _a !== void 0 ? _a : customerDeleted,
        },
        services: [
            {
                id: appointmentDto.service_id,
                name: appointmentDto.service_name,
                staff: appointmentDto.staff_id !== null
                    ? {
                        id: appointmentDto.staff_id,
                        firstName: appointmentDto.staff_first_name,
                        lastName: appointmentDto.staff_last_name,
                        avatar: appointmentDto.staff_image,
                        incorrectAssigned: appointmentDto.incorrect_assigned,
                        overassigned: appointmentDto.overassigned,
                    }
                    : undefined,
                businessArea: masterData.businessAreas.find(function (ba) { return ba.id === appointmentDto.service_business_area; }),
                hasReport: appointmentDto.service_has_report,
                price: appointmentDto.service_price,
            },
        ],
        status: masterData.workflow.find(function (step) { return step.status.id === appointmentDto.status; }).status,
        duration: {
            from: moment(appointmentDto.booked_at).tz(timeZone),
            to: moment(appointmentDto.booking_end_at).tz(timeZone),
        },
        notes: appointmentDto.notes,
        total: Number(appointmentDto.total),
        invoiceId: appointmentDto.invoice_id,
        createAt: moment(appointmentDto.created_at),
        updatedAt: moment(appointmentDto.updated_at),
        createdBy: appointmentDto.created_by,
        recurringUuid: appointmentDto.recurring_uuid,
        recurringFrecuency: masterData.scheduleFrecuency.find(function (frequency) { return frequency.id === appointmentDto.schedule_frequency_id; }),
        destroyable: appointmentDto.destroyable,
        reports: {
            dentalReportId: appointmentDto.report_dental_id,
            groomingReportId: appointmentDto.report_grooming_id,
        },
        cancelationReasonId: appointmentDto.cancelation_reason_id,
        orderId: appointmentDto.order_id,
        isPaid: appointmentDto.paid,
    };
};
var convertBreed = function (appointmentDto, masterData) {
    return getBreed(appointmentDto.pet_breed, appointmentDto.pet_type, masterData);
};
export var convertToLog = function (logDto) {
    return {
        id: logDto.id,
        marketplaceId: logDto.marketplace_id,
        bookingId: logDto.booking_id,
        addressId: logDto.address_id,
        appointmentId: logDto.appointment_id,
        visitId: logDto.visit_id,
        staffId: logDto.staff_id,
        customerId: logDto.customer_id,
        petId: logDto.pet_id,
        uuid: logDto.uuid,
        status: logDto.status,
        logDescription: logDto.log_description,
        createdAt: moment(logDto.created_at),
        updatedAt: moment(logDto.updated_at),
    };
};
export var getBreed = function (breedId, petTypeId, masterData) {
    return getMasterDataBreeds(petTypeId, masterData).find(function (breed) { return breed.id === breedId; });
};
export var getMasterDataBreeds = function (petTypeId, masterData) {
    if (petTypeId === PetTypeIds.DOGS) {
        return masterData.breeds.dogs;
    }
    else if (petTypeId === PetTypeIds.CATS) {
        return masterData.breeds.cats;
    }
    else if (petTypeId === PetTypeIds.EXOTICS) {
        return masterData.breeds.exotics;
    }
    else {
        return [];
    }
};
export var convertToRecurrent = function (dto, masterData, timeZone) { return ({
    remaining: dto.remaining,
    total: dto.total,
    frecuency: masterData.scheduleFrecuency.find(function (frecuency) { return frecuency.id === dto.schedule_frequency_id; }),
    lastDate: moment(dto.last_date).tz(timeZone),
}); };
